<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加就诊记录</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="height: 400px;">
        <el-form :model="addForm" ref="addForm" :rules="rules" :disabled='disabled'>
          <el-row>

              <el-col :span="24" >

                <el-col :span="12" class="item" >
                  <el-form-item label="就诊医院" required prop="hospital">
                    <el-input v-model="addForm.hospital" clearable placeholder="请输入就诊医院"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12" class="item">
                  <el-form-item label="就诊时间" required prop="seeDoctorTime">
                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="addForm.seeDoctorTime"
                        type="date"
                        placeholder="选择日期"
                        style="width:100%"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
<!--                <el-col :span="8" class="item" >-->
<!--                  <el-form-item label="陪诊人员" required prop="entourage">-->
<!--                    <el-input v-model="addForm.entourage" clearable placeholder="请输入陪诊人员"></el-input>-->
<!--                  </el-form-item>-->
<!--                </el-col>-->


              </el-col>

              <el-col :span="12" class="item" >
                <el-form-item label="就诊内容" prop="physicalExamination">
                  <el-input
                      type="textarea"
                      clearable
                      :rows="5"
                      placeholder="请输入检查内容"
                      v-model="addForm.physicalExamination"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12" class="item" clearable >
                <el-form-item label="诊断结果" prop="diagnosisResults">
                  <el-input
                      type="textarea"
                      :rows="5"
                      placeholder="请输入诊断结果"
                      v-model="addForm.diagnosisResults"
                  ></el-input>
                </el-form-item>
              </el-col>


          </el-row>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";

export default {
  name: "Role",
  data() {
    return {


      elderlyName: "",
      elderlyPhone:"",
      loading: false,

      addForm: {
        timeStr: timeStr,
        staffCode: getStaffCode(),
        sign: "",
        userCode: "",
        elderlyCode: "",

        entourage:'',

        hospital: "",
        department: "",
        doctor: "",
        seeDoctorTime: "",
        furtherTime: "",
        chiefComplaint: "",
        physicalExamination: "",
        realityExamination: "",
        auxiliaryExamination: "",
        useMedication: "",
        diagnosisResults: "",
        treatmentPrescription: "",
        aboutTaboo: "",
      },

      rules: {
        hospital: [
          { required: true, message: "请输入医院名称", trigger: "blur" },
        ],
        entourage:[
          { required: true, message: "请输入陪诊人员", trigger: "blur" },
        ],
        department: [
          { required: true, message: "请输入就诊科室", trigger: "blur" },
        ],
        doctor: [
          { required: true, message: "请输入就诊医生", trigger: "blur" },
        ],
        seeDoctorTime: [
          { required: true, message: "请选择就诊时间", trigger: "blur" },
        ],
      },

    };
  },
  created() {},
  components: {},
  watch: {
    //监听全局变量
    "$store.state.tableHeight": function () {},
  },
  methods: {

    init(elderlyCode, userCode) {
      this.$refs.addForm.resetFields();
      this.addForm.elderlyCode = elderlyCode;
      this.addForm.userCode = userCode;
    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    addSubmit() {
      if (this.loading) {
        return;
      } else {
        this.loading = true;
      }
      this.addForm.sign = hex_md5(
        "timeStr=" + timeStr + "&key=" + this.$signKey
      );
      this.$axios({
        method: "post",
        url: this.$shopUrl + "ESeeDoctorRecord/Add",
        data: this.addForm,
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("resultSuccess");
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>

</style>
